/* eslint-disable prettier/prettier */
/* eslint-disable import/no-unresolved */
import { configureStore } from '@reduxjs/toolkit';

// reducers
import authReducer from './features/auth/authSlice';

export default configureStore({
  reducer: {
    auth: authReducer
  }
});
